import React from 'react';
import { Button } from 'semantic-ui-react';
import styled from 'styled-components';
import { ReactComponent as PoweredBy } from '../images/PoweredBy.svg';
import { FormPageProps } from '../types/props';
import './FormPage.scss';

type FormPageInternalProps = {
  valid?: boolean;
  noButtons?: boolean;
  children?: React.ReactNode;
  enablePrev?: boolean;
  errorMessage?: string;
} & FormPageProps;

const ErrorMessage = styled.p`
  text-align: center;
  margin-top: 3rem;
  font-size: 14px;
  color: #f16778;
`;

function FormPage(props: FormPageInternalProps): JSX.Element {
  const BgImage =
    props.layout?.headerImage === 'http://www.example.com/image.jpg'
      ? 'url(/ApplicationHeader.png)'
      : `url(${props.layout?.headerImage})`;
  const logoImage =
    props.layout?.logoImage === 'http://www.example.com/image.jpg'
      ? '/AplicationAgencyLogo.jpg'
      : props.layout?.logoImage;
  return (
    <div className='form-page' style={{ backgroundColor: `${props.layout?.backgroundColor}` }}>
      <div
        className='form-header'
        style={{
          backgroundImage: BgImage,
          backgroundSize: 'cover',
        }}
      >
        {props.layout && <img className='form-header-logo' src={logoImage} alt='' />}
      </div>
      {props.errorMessage && <ErrorMessage>{props.errorMessage}</ErrorMessage>}
      <div className='form-body'>{props.children}</div>
      <div className='form-footer'>
        <div className='form-footer-logo'>
          <PoweredBy />
        </div>
        {!props.noButtons && (
          <>
            {props.enablePrev && (
              <Button id='form-cancel' onClick={props.onCancel}>
                Prev
              </Button>
            )}
            <Button id='form-submit' disabled={!props.valid} onClick={props.onSubmit}>
              Next
            </Button>
          </>
        )}
      </div>
    </div>
  );
}

export default FormPage;
